import React from 'react';
import { t } from 'i18next';
import {
    Popover,
    PopoverTrigger,
    Flex,
    Avatar,
    Box,
    PopoverContent,
    PopoverArrow,
    PopoverBody,
    Text
} from '@chakra-ui/react';

import { LandClass } from '../../../core/land';
import { UserClass } from '../../../core/user';

interface UserBoxProps {
    guest: UserClass;
    land?: LandClass;
    hasEmail?: boolean;
    size?: 'xs' | 'sm' | 'md' | 'lg';
}

export default function UserPopover({
    guest,
    land
}: UserBoxProps): React.ReactElement {
    return (
        <Popover trigger='hover' openDelay={500}>
            <PopoverTrigger>
                <Box>
                    <UserBox guest={guest} land={land} />
                </Box>
            </PopoverTrigger>
            <PopoverContent>
                <PopoverArrow />
                <PopoverBody>
                    <UserBox
                        guest={guest}
                        land={land}
                        size='md'
                        hasEmail={true}
                    />
                </PopoverBody>
            </PopoverContent>
        </Popover>
    );
}

export function UserBox({
    guest,
    land,
    hasEmail = false,
    size = 'xs'
}: UserBoxProps): React.ReactElement {
    const fontSize = {
        xs: 'md',
        sm: 'lg',
        md: 'xl',
        lg: '2xl'
    };
    return (
        <Flex align={'center'} cursor='pointer'>
            <Avatar
                bg='white'
                size={fontSize[size]}
                name={guest.name}
                src={guest.getImage()}
            />
            <Box pl='2' noOfLines={1}>
                <Text fontSize={size} noOfLines={1}>
                    {guest.name}
                </Text>
                {hasEmail && (
                    <Text fontSize={size} noOfLines={1}>
                        {guest.email}
                    </Text>
                )}
                {!!land && (
                    <Text fontSize={size} noOfLines={1}>
                        {land.readers.includes(guest.id)
                            ? (t('land.reader') as string)
                            : (t('land.editor') as string)}
                    </Text>
                )}
            </Box>
        </Flex>
    );
}
